  import { useState } from "react";
  import { useNavigate } from "react-router-dom";
  import axios from "axios";
  import GridScan from "./GridScan"; // adjust path if needed
  import "../CSS/Login.css";

  const Login = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const params = new URLSearchParams();
    params.append("realm", "navaantrix");
    params.append("clientId", "swagger");
    params.append("username", username.trim());
    params.append("password", password.trim());

    try {
      setLoading(true);

      const { data } = await axios.post(
        "https://admin-portal-kc.navaantrix.com/keycloak/api/users/login",
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
  
  // console.log("LOGIN DATA:", data);

  const tokenData = data.data;
      // Store tokens properly
      localStorage.setItem("access_token", tokenData.access_token);
      localStorage.setItem("refresh_token", tokenData.refresh_token);
      localStorage.setItem("expires_in", tokenData.expires_in);
      localStorage.setItem("token_type", tokenData.token_type);

      // console.log("TOKEN STORED:", localStorage.getItem("access_token"));
       
      navigate("/", { replace: true });
      window.location.reload();

    } catch (err) {
      setError("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };


    return (
      <div className="login-page">
        {/* Background */}
        <div className="login-bg">
          <GridScan
            sensitivity={0.55}
            lineThickness={1}
            linesColor="#392e4e"
            gridScale={0.1}
            scanColor="#FF9FFC"
            scanOpacity={0.4}
            enablePost
            bloomIntensity={0.6}
            chromaticAberration={0.002}
            noiseIntensity={0.01}
          />
        </div>

        {/* Login Card */}
        <div className="login-card">
          <h2>Sign in</h2>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && <p className="form-error">{error}</p>}

            <button
              type="submit"
              className="login-btn"
              disabled={loading}
            >
              <span>{loading ? "LOGGING IN..." : "LOGIN"}</span>
              <span className="arrow">→</span>
            </button>

            <p
              className="signup-link"
              onClick={() => navigate("/signup")}
            >
              Create Account
            </p>
          </form>
        </div>
      </div>
    );
  };


  

  export default Login;

